"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_ObidiahsBlessing_OnBurningAppliedEventHandlerScript = void 0;
const EffectType_1 = require("../../core/effects/EffectType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const Logger_1 = require("../../Logger");
let Effect_ObidiahsBlessing_OnBurningAppliedEventHandlerScript = class Effect_ObidiahsBlessing_OnBurningAppliedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.EffectApplied) {
            return;
        }
        const effect = container.getEffect(event.args.effectId);
        if (effect.args.__typeName !== "Burning") {
            return;
        }
        else if (container.getEffectsOfType(event.subject, EffectType_1.EffectType.Burning).length > 50) {
            Logger_1.EngineLogger.error(`500|TooManyBurnStacks|adventureId#${container.adventure.adventureId}`);
            return;
        }
        effect.args.power *= 2;
    }
};
Effect_ObidiahsBlessing_OnBurningAppliedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_ObidiahsBlessing_OnBurningApplied")
], Effect_ObidiahsBlessing_OnBurningAppliedEventHandlerScript);
exports.Effect_ObidiahsBlessing_OnBurningAppliedEventHandlerScript = Effect_ObidiahsBlessing_OnBurningAppliedEventHandlerScript;
